import { FC, useEffect, useState } from 'react';
import { Avatar, Button, Dropdown, Menu } from 'antd';
import { TbDotsVertical, TbEdit, TbTrash } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { VirtualizedList as List } from '@/shared';
import { DropdownMenuPanel } from '@/shared/components/dropdowns/DropdownPanel';
import RenameResourceModal from '@/shared/components/modals/ResourceActionModals/01-RenameResourceModal';
import DeleteResourceModal from '@/shared/components/modals/ResourceActionModals/03-DeleteResourceModal';
import { MiddleDot } from '@/shared/components/typography';
import { imgLogoStyling } from '@/theme';
import { formatDate } from '@/utilities';

interface ManageDataSourceListItemProps {
    i: any;
    indx: number;
}

const ManageDataSourceListItem: FC<ManageDataSourceListItemProps> = ({ i, indx }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    const ca = i?.connectedAccount;

    const [renameOpen, setRenameOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    return (
        <List.Item key={i?.key} style={{ paddingTop: indx === 0 ? 0 : '0.5rem' }}>
            <List.Item.Meta
                avatar={
                    <div style={{ marginTop: '0.25rem' }}>
                        <Avatar
                            size={'large'}
                            icon={
                                i?.src ? (
                                    <img
                                        alt=''
                                        src={i?.src}
                                        style={{
                                            ...i?.avatarStyling,
                                            ...imgLogoStyling,
                                        }}
                                    />
                                ) : (
                                    i?.icon
                                )
                            }
                            shape='square'
                            style={{
                                backgroundColor: token.colorBgBase,
                                borderRadius: token.borderRadius,
                                border: `1px solid ${token.colorBorder}`,
                                marginRight: '-0.25rem',
                            }}
                        />
                    </div>
                }
                title={<span style={{ fontWeight: 500 }}>{i?.label}</span>}
                description={
                    // <Row align='middle'>
                    //     <Col flex='none'>
                    //         {i?.categories?.map((category: any) => {
                    //             return (
                    //                 <SmallTag
                    //                     styles={{ marginLeft: 0, marginRight: '0.5rem' }}
                    //                     message={
                    //                         <span style={{ verticalAlign: '0.5px' }}>
                    //                             {category?.icon}
                    //                             {category?.label}
                    //                         </span>
                    //                     }
                    //                 />
                    //             );
                    //         })}
                    //     </Col>
                    // </Row>
                    <small>
                        Connected {i?.createdAt && formatDate(i.createdAt)}
                        {i?.updatedAt && (
                            <>
                                <MiddleDot horizontalMargin={'0.5rem'} />
                                Last synced {formatDate(i.updatedAt)}
                            </>
                        )}
                    </small>
                }
            />
            <Dropdown
                trigger={['click']}
                placement='bottomRight'
                popupRender={() => (
                    <DropdownMenuPanel style={{ marginTop: '0.5rem', width: 16 * 16 }}>
                        <Menu.Item key='editName' icon={<TbEdit size='1rem' />} onClick={() => setRenameOpen(true)}>
                            Edit Alias
                        </Menu.Item>
                        {/* <Menu.Item key='refresh' icon={<TbRefresh size='1rem' />}>
                            Refresh Connection to Data Source
                        </Menu.Item> */}
                        <Menu.Divider />
                        <Menu.Item
                            danger
                            key='remove'
                            icon={<TbTrash size='1rem' />}
                            onClick={() => setDeleteOpen(true)}
                        >
                            Delete
                        </Menu.Item>
                    </DropdownMenuPanel>
                )}
            >
                <Button size='small' onClick={i?.handler}>
                    <TbDotsVertical style={{ color: token.colorTextTertiary }} />
                </Button>
            </Dropdown>
            <RenameResourceModal
                resource={ca}
                singularResource={'connected-account'}
                open={renameOpen}
                setOpen={setRenameOpen}
            />
            <DeleteResourceModal
                resource={ca}
                singularResource={'connected-account'}
                open={deleteOpen}
                setOpen={setDeleteOpen}
            />
        </List.Item>
    );
};

export default ManageDataSourceListItem;
